import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_card",
  "use": "icon_card-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon_card\"><path d=\"M5 16h2v1H5zm4 0h6v1H9z\" fill=\"currentColor\" /><path d=\"M4 5v13h12V5H4zm3 12H5v-1h2v1zm8 0H9v-1h6v1zM4 4V2h12v2H4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol